@if (debouncedUserQueryIsPending()) {
  <div
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-4 justify-center"
  >
    <img
      src="assets/icons/logo.svg"
      alt="COI Energy"
      class="h-16 animate-in slide-in-from-top duration-1000"
    />
    <mat-progress-spinner mode="indeterminate" color="primary" diameter="40"></mat-progress-spinner>
  </div>
} @else {
  <!-- E2X-2035: visual feedback during route transitions so a slow lazy-load
       (e.g. the admin dashboard chunk after select-role) doesn't look hung. -->
  @if (isNavigating()) {
    <mat-progress-bar
      mode="indeterminate"
      color="primary"
      class="!fixed !top-0 !left-0 z-50"
    ></mat-progress-bar>
  }
  <router-outlet />
  <!-- Live toast notifications container (shown during normal app state when enabled) -->
  @if (showLiveProofs) {
    <app-live-toasts></app-live-toasts>
  }
}
